import { useCallback, useEffect, useMemo, type ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { parseSiteLocale, persistSiteLocale, SiteLocaleContext, useSiteLocale } from "./useSiteLocale";
import type { Locale } from "@/types";

export function SiteLocaleProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const navigate = useNavigate();
  const stored = useSiteLocale();
  const locale = parseSiteLocale(new URLSearchParams(location.search).get("lang")) ?? stored.locale;
  useEffect(() => { persistSiteLocale(locale); }, [locale]);
  const setLocale = useCallback((next: Locale) => {
    const search = new URLSearchParams(location.search);
    if (search.get("lang") === next) return;
    search.set("lang", next);
    void navigate({ ...location, search: search.toString() }, { replace: true, state: location.state });
  }, [location, navigate]);
  const value = useMemo(() => ({ locale, setLocale }), [locale, setLocale]);
  return <SiteLocaleContext.Provider value={value}>{children}</SiteLocaleContext.Provider>;
}
